import { isChrome, isEdge, isMobile } from 'react-device-detect'

// edgeは正式にはMiROHAでサポートしているブラウザではないが、chromiumベースなのと実際にwindowsユーザーが多く使用しているのでサポートする
export const isScreenShareSupported = !isMobile && (isChrome || isEdge)
